import { AsyncKey } from "constants/index";
import Cookies from "js-cookie";
import languages from "languages";

const t = () => {
  const langCookie: any = Cookies.get(AsyncKey.languageKey);
  const selectedLanguage: "vi" | "en" = langCookie || "vi";
  return languages[selectedLanguage];
};

export const getCurrentLanguage = () => {
  const langCookie: any = Cookies.get(AsyncKey.languageKey);
  const selectedLanguage: "vi" | "en" = langCookie || "vi";
  return selectedLanguage;
};

export default t;
